import type {
  PDFSplitFunction,
  Pixel,
  SpatialRectangle,
} from "@pdfking/renderer-api"
import { BlobToUint8, IterableToArray, Range, ToBlob } from "@pdfking/tfunc"
import { PDFDocument } from "pdf-lib"

export const PDFSplit: PDFSplitFunction = async function* (input, rangeFn) {
  const blobs = await IterableToArray(input.stream)
  const blob = ToBlob(blobs)
  const bytes = await BlobToUint8(blob)
  const doc = await PDFDocument.load(bytes, {
    ignoreEncryption: true,
    updateMetadata: false,
  })

  const page_count = doc.getPageCount()
  const pages = (rangeFn ?? (c => Range(1, c)))(page_count)

  for (const page of pages) {
    const newDoc = await PDFDocument.create()
    const [copy] = await newDoc.copyPages(doc, [page - 1])
    newDoc.addPage(copy)

    yield {
      blob: ToBlob([await newDoc.save()], "application/pdf"),
      trim_box: copy.getTrimBox() as SpatialRectangle<Pixel>,
      media_box: copy.getMediaBox() as SpatialRectangle<Pixel>,
    }
  }
}
